import axios from "axios";
import store from "../../store/index";
import ModuleModal from './Modulemodal.vue';

export default {
  name: 'Logs',

  components: {
    ModuleModal
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      isLoading: false,
      modules: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      sortProperty: 'displayOrder',
      sortOrder: 1,
      expandedRows: [],
    }
  },

  computed: {
    totalPages() {
      return Math.max(Math.ceil(this.totalCount / this.pageSize), 1);
    },

    pageStart() {
      return this.totalCount === 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1;
    },

    pageEnd() {
      return Math.min(this.currentPage * this.pageSize, this.totalCount);
    },
  },

  methods: {
    async fetchModules(page) {
      const targetPage = page || this.currentPage;
      this.isLoading = true;
      try {
        const response = await axios.get(`${this.baseUrl}/admin/appmodule/getall`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.idToken}`,
          },
          params: {
            pageindex: targetPage,
            pagesize: this.pageSize,
            SortProperty: this.sortProperty,
            SortOrder: this.sortOrder,
          }
        });

        const entities = response.data.entities || [];
        this.totalCount = response.data.totalCount || 0;

        this.modules = entities.map(e => ({
          id: e.id,
          moduleId: e.moduleId,
          code: e.moduleCode,
          name: e.moduleName,
          description: e.description,
          order: e.displayOrder,
          active: e.isActive,
          icon: e.icon,
          route: e.route,
          category: e.category,
          isSystemModule: e.isSystemModule,
          tenantConfigurable: e.tenantConfigurable,
          licenseRequired: e.licenseRequired,
          defaultEnabled: e.defaultEnabled,
          version: e.version,
          tags: e.tags,
        }));

        this.currentPage = targetPage;

        if (this.modules.length === 0 && this.currentPage > 1) {
          this.fetchModules(this.currentPage - 1);
          return;
        }

      } catch (error) {
        const responseData = error.response && error.response.data;
        const message = (responseData && responseData.message) || error.message || 'Failed to fetch modules';
        alert(`Error: ${message}`);
        console.error('Error fetching modules:', error);
      } finally {
        this.isLoading = false;
      }
    },

    openAddModule() {
      this.$refs.moduleModal.openModuleModal();
    },

    openEditModule(module) {
      this.$refs.moduleModal.openModuleModal(module);
    },

    onModuleSaved() {
      this.fetchModules(this.currentPage);
    },

    async deleteModule(module) {
      if (!confirm(`Delete module "${module.name}"? This cannot be undone.`)) {
        return;
      }

      try {
        await axios.delete(`${this.baseUrl}/admin/appmodule/delete?id=${encodeURIComponent(module.id)}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.idToken}`
          }
        });
        alert('Module deleted successfully');
        this.fetchModules(this.currentPage);
      } catch (error) {
        const responseData = error.response && error.response.data;
        const message = (responseData && responseData.message) || error.message || 'Failed to delete module';
        alert(`Error: ${message}`);
        console.error('Error deleting module:', error);
      }
    },

    onActions(module) {
      this.$emit('module-actions', module);
    },

    isExpanded(id) {
      return this.expandedRows.indexOf(id) !== -1;
    },

    toggleDescription(id) {
      const idx = this.expandedRows.indexOf(id);
      if (idx === -1) {
        this.expandedRows.push(id);
      } else {
        this.expandedRows.splice(idx, 1);
      }
    },

    goToPage(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) {
        return;
      }
      this.fetchModules(page);
    },

    prevPage() {
      this.goToPage(this.currentPage - 1);
    },

    nextPage() {
      this.goToPage(this.currentPage + 1);
    },
  },

  mounted() {
    this.fetchModules(1);
  },
}